import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { StyledImage } from "../../Styled/Image"
import { H1 } from "../../Styled/Text"

export const Banner = tw.section`relative bg-teal-dark py-12 md:pt-21 md:pb-28`
export const Image = styled(StyledImage)`
  ${tw`inset-0`}
  position: absolute !important;
`
export const Title = tw(H1)`relative`
